import { render, staticRenderFns } from "./textToSpeech.vue?vue&type=template&id=9e8e21e6&scoped=true&"
import script from "./textToSpeech.vue?vue&type=script&lang=js&"
export * from "./textToSpeech.vue?vue&type=script&lang=js&"
import style0 from "./textToSpeech.vue?vue&type=style&index=0&id=9e8e21e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e21e6",
  null
  
)

export default component.exports